@if (entry.base?.display) {
  <a  href="{{entry?.custom?.link}}" target="_blank" rel="noopener noreferrer">{{entry?.formControlAttributes?.label}}</a>
}
